var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreditPicker',{attrs:{"value":_vm.value,"columns":_vm.columns,"title":_vm.title,"aria-label":_vm.ariaLabel,"placeholder":"Не задан","width":470,"disabled":_vm.disabled,"has-error":_vm.hasError},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }